import { render, staticRenderFns } from "./RegraForm.vue?vue&type=template&id=7da6f8b6"
import script from "./RegraForm.vue?vue&type=script&lang=js"
export * from "./RegraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports